<template>
  <div class="page">
    <navigation
      type="second-level"
      :sticky="true"
      @click="detention"
      :customClickEvent="true"
      v-if="!showPayLoading"
    >
      我要提现
    </navigation>

    <!-- 顶部金额信息 -->
    <div class="amount-info">
      <img class="tip-image" src="./image/img_passcard_funder.png">
      <div class="title">
        <span>直供额度 (元)</span>
      </div>
      <div class="amount">{{ form.applyAmt | amount}}</div>
      <div class="split" />
    </div>
    <!-- 表单 -->
    <form class="form card-panel">
      <div class="form-item underline-un-focus">
        <nd-choose
          label="怎么花"
          :valueKey="['key', 'description']"
          :data="dictionary.loanPurpose"
          v-model="form.purpose"
          @change="purposeChange"
        >
        </nd-choose>
      </div>

      <div class="form-item underline-un-focus">
        <nd-choose
          label="分几期"
          :data="termList"
          :placeholder="placeholder"
          v-model="form.applyTerm"
          :beforeClick="beforeSelectTerm"
          @change="termChange"
        >
        </nd-choose>
      </div>
    </form>

    <div class="bottom">
      <div class="preview" :class="{'disabled': isDisabled}" @click="next" data-sensors-click>
        <div class="title">{{ !isDisabled ? '预览提现详情' : '暂不可提现' }}</div>
        <div v-if="countdownVisible&&!isDisabled" class="count-down">通道关闭
          <van-count-down :time="countDownSeconds" @finish="countDownEnd">
            <template #default="timeData">
              {{ timeFormat(timeData.hours) }}:{{ timeFormat(timeData.minutes) }}:{{ timeFormat(timeData.seconds) }}
            </template>
          </van-count-down>
        </div>
      </div>
      <div class="tip">
        综合年化利率以实际每笔订单放款审核为准
      </div>
    </div>

    <div class="pay-loading" v-if="showPayLoading">
      <span class="back" @click="backHome">返回首页</span>
      <div class="lottie-contaienr">
        <lottie
          ref="animataion"
          :options="showGif"
        />
        <p>订单支付中</p>
      </div>
    </div>

    <service-pass v-model="isBigPrivilegeRefund" />
  </div>
</template>

<script>
import { CountDown } from 'vant'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getKey, removeKey, judgeClientSystem } from '@/assets/utils'
import Lottie from 'vue-lottie'
import { wait } from '@/assets/json/index'
import ServicePass from './components/service-pass.vue'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

const WITHDRAW_PASSCARD_FORM_KEY = 'withdrawForm'

export default {
  components: {
    CountDown,
    Lottie,
    ServicePass
  },
  data () {
    return {
      detentionVisible: false,
      productSubList: [],
      amtProductList: [],
      countDownSeconds: 900 * 1000,
      fundCode: '',
      canLoanApply: true,
      showPayLoading: false,
      showGif: { animationData: wait },
      orderNo: this.$route.query.partnerOrderNumber,
      form: {
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        bankCardNo: ''
      },
      isBigPrivilegeRefund: false
    }
  },
  computed: {
    ...mapState({
      dictionary: state => state.dictionary
    }),
    termList () {
      if (!this.productSubList || this.productSubList.length === 0) {
        return []
      }
      var cycles = this.amtProductList.map((item) => {
        return {
          name: item + '个月',
          value: item
        }
      })
      return cycles
    },
    placeholder () {
      return this.termList.length > 0 ? '请选择' : '暂无支持分期'
    },
    isDisabled () {
      return this.isEmptyString(this.form.applyAmt) ||
        this.isEmptyString(this.form.applyTerm) ||
        this.isEmptyString(this.form.purpose) ||
        !this.canLoanApply
    },
    countdownVisible () {
      return this.countDownSeconds > 0
    }
  },
  async created () {
    if (this.orderNo) {
      await this.pollBuyVipResult()
    } else {
      this.init()
    }
    this.getLoanDetentionPopType({
      reqType: 'LOAN'
    })
    this.$bus.$emit('ready')
  },
  beforeDestroy () {
    clearTimeout(window.timmer)
  },
  methods: {
    ...mapMutations('withdraw', ['setWithdrawForm']),
    ...mapActions('withdraw', [
      'getLoanParameterX',
      'amtProductX',
      'getFundRouteX',
      'canLoanX',
      'judgeMissingX',
      'getLoanTrialX',
      'getLoanDetentionPopType'
    ]),
    ...mapActions('vip', ['buyVipResult']),
    ...mapActions(['fetchDictionaryX']),
    async init () {
      await Promise.all([
        this.fetchDictionary(),
        this.getLoanParameter()
      ])
      await this.getAmountProduct(this.form.applyAmt)
      await this.canLoan()
    },
    // 轮询通过buyVipResult查询是否购买成功
    async pollBuyVipResult () {
      this.showPayLoading = true
      const { success, data } = await this.buyVipResult({
        orderNo: this.orderNo
      })
      if (success) {
        const { memberOpenStatus } = data
        // INIT :初始化 WAIT :准备开通 CANCEL :取消 SUC :成功 FAIL :失败
        if (['INIT', 'WAIT'].includes(memberOpenStatus)) {
          window.timmer = setTimeout(() => {
            this.pollBuyVipResult()
          }, 3000)
        } else if (memberOpenStatus === 'SUC') {
          this.showPayLoading = false
          this.init()
        } else {
          this.$router.push('/middle/limit')
        }
      }
    },
    async fetchDictionary () {
      const dict = await this.fetchDictionaryX()
      this.form.purpose = dict.loanPurpose[0].key
    },
    // 查询借款参数
    async getLoanParameter () {
      const response = await this.getLoanParameterX({
        loanPlatform: 'TMD',
        passCardProcess: 'Y'
      })
      if (response.success && response.data) {
        this.form.applyAmt = response.data.productDefaultAmt
        this.productSubList = response.data.productSubList
      }
    },
    // 通过金额查询子产品 - 分期数据来源
    async getAmountProduct (applyAmount) {
      const response = await this.amtProductX({
        loanPlatform: 'TMD',
        applyAmount: applyAmount,
        passCardProcess: 'Y'
      })
      if (response.success) {
        let terms = response.data
        this.amtProductList = terms
        if (terms && terms.length > 0) {
          this.form.applyTerm = terms[terms.length - 1]
        }
      } else {
        this.amtProductList = []
      }
    },
    // 当前是否可借款
    async canLoan () {
      const response = await this.canLoanX({
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || '',
        passCardProcess: 'Y'
      })
      if (response.success) {
        const { code, canLoanApply } = response.data
        this.canLoanCode = code
        this.canLoanApply = canLoanApply
        if (code === 'F_000051') {
          // 未做OCR
          this.judge({ h5: '/authentication/id', native: 'ocr' })
        } else if (code === 'F_000023') {
          // OCR过期
          this.$router.replace('/authentication/supplementaryOCR?status=expired')
        }
      }
    },
    async getFundRoute () {
      const params = {
        routeType: 'LOAN',
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt,
        totatlTermNo: this.form.applyTerm,
        productCode: 'TMDP',
        passCardProcess: 'Y'
      }
      const response = await this.getFundRouteX(params)
      

      if (response.code === '100006') {
        this.isBigPrivilegeRefund = true
        return
      }
      if (response.success) {
        if (!response.data || response.data.length === 0) {
          this.$message('今日额度已抢完，明天再来吧')
        } else {
          this.$storage.set('fundRoute', response.data[0])
          this.fundCode = response.data[0].fundCode
        }
      } else {
        this.$storage.remove('fundRoute')
        this.$message(response.msg)
      }
    },
    async next () {
      if (this.isDisabled) {
        return
      }
      this.$storage.set(WITHDRAW_PASSCARD_FORM_KEY, this.form)
      this.setWithdrawForm(this.form) // 不能借款时，拦截
      const canLoanRes = await this.canLoanX({
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt || '',
        totalTermNo: this.form.applyTerm || '',
        passCardProcess: 'Y'
      })
      if (!canLoanRes.success || !canLoanRes.data.canLoanApply) {
        return
      }
      this.$indicator()
      await this.getFundRoute()
      if (!this.fundCode) {
        this.$indicator.close()
        return
      }
      const response = await this.getLoanTrialX({
        loanTerm: this.form.applyTerm,
        withdrawAmt: this.form.applyAmt,
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        repayMethod: 'AI',
        productCd: 'TMDP'
      })
      this.$indicator.close()
      if (response.success) {
        this.$storage.set('repayTrail', response.data)
        const res = await this.judgeMissingX()
        if (res.success && res.data.missing) {
          let value = getKey('channel') !== 'API-XHQB' ? 'F' : 'T'
          this.$router.push({
            path: '/authentication/smallFlowerBase',
            query: { notify: value, fundCode: this.fundCode, passCardProcess: 'Y' }
          })
        } else {
          removeKey('withdrawButtonHasBeenClicked')
          this.$router.push({
            path: '/withdraw/preview',
            query: { fundCode: this.fundCode, passCardProcess: 'Y', couponSerialNos: this.$route.query.couponSerialNos }
          })
        }
        this.$storage.set(WITHDRAW_PASSCARD_FORM_KEY, this.form)
      }
    },
    // 点击返回挽留弹窗
    detention () {
      // this.$refs.backPopup.init()
      this.back()
    },
   
    beforeSelectTerm () {
      if (this.termList.length === 0) {
        return Promise.resolve(false)
      }
      return Promise.resolve(true)
    },
    // 怎么花
    purposeChange (item) {
      this.$report({
        id: 10088,
        args: {
          target: item.value
        }
      })
    },
    // 期数选择
    termChange (item) {
      this.$report({
        id: 10089,
        args: {
          target: item.value
        }
      })
    },
    // 倒计时结束
    countDownEnd () {
      this.countDownSeconds = 0
    },
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    judge (path) {
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true, couponSerialNos: this.$route.query.couponSerialNos })
      } else {
        this.$router.replace(path.h5)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #FAFAFA;
  .pay-loading {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    display: flex;
    background: #fff;
    justify-content: center;
    .back {
      float: right;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-decoration: underline;
      text-align: right;
      padding:30px;
      z-index: 9;
      position: absolute;
      right: 0;
    }
    .lottie-contaienr {
      margin-top: 300px;
      width: 210px;
      height: 210px;
    }
    p {
      font-size: 34px;
      text-align: center;
      margin-top: 30px;
      font-weight: bold;
    }
  }
  .amount-info {
    margin-top: 20px;
    background: #FFFFFF;
    padding: 30px 0 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tip-image {
      margin-left: 340px;
      width: 370px;
      height: 68px;
    }
    .title {
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 42px;
      margin-top: 12px;
    }
    .amount {
      font-size: 72px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #333333;
      line-height: 87px;
    }
  }

  .card-panel {
    background-color: #fff;
    margin-top: 20px;
  }

  .form {
    padding: 0 30px;
    .form-item {
      height: 110px;
      line-height: 110px;
      margin-top: 0;

      .nd-choose {
        label {
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        input {
          font-size: 30px;
        }

        textarea {
          font-size: 30px;
        }
      }
    }
  }

  .bottom {
    background-color: #fff;
    height: 230px;
    width: 750px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    bottom: 0;
    .preview {
      width: 650px;
      height: 94px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 47px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 30px;
      color: #FFFFFF;
      &.disabled {
        background: #DDDDDD !important;
      }
      .title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 45px;
      }
      .count-down {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 28px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .van-count-down {
          margin: 0 5px;
          font-size: 20px;
          color: #fff;
        }
      }
    }
    .tip {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      margin-top: 25px;
    }
  }

  .detention-dialog {
    .detention-title {
      margin: 0 20px;
      text-align: center;
      font-size: 36px;
      line-height: 50px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      padding-bottom: 34px;
      border-bottom: 1px solid #EEEEEE;
      span {
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,70,51,1);
        line-height:50px;
      }
    }
    .giveup {
      li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: @fc3;
        border-bottom: 1px solid #EEEEEE;
      }
    }

    .continue {
      border: 0px solid transparent;
      height: 160px;
      line-height: 160px;
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      color: @theme;
      width: 100%;
      -webkit-appearance: none;
      outline: none;
      background-color: #FFFFFF;
    }
  }
}
</style>